import React from 'react';

const Loading = () => {
    return (
        <div className='grid items-center justify-center'>
            <button className="btn loading">loading</button>
        </div>
    );
};

export default Loading;